import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-solutions',
  templateUrl: './solutions.component.html',
  styleUrls: ['./solutions.component.css']
})
export class SolutionsComponent implements OnInit {
  title = 'WorldERP.com Solutions';

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {property: 'og:title', content: 'WorldERP.com Solutions'},
      {property: 'og:type', content: 'solutions'},
      {property: 'og:url', content: '/solutions'},
      {property: 'og:image', content: ''}
    ]);
  }

}
